$(document).ready ->
  $('#essay_page_mandatory_correct').on 'click', ->
    if $('#essay_page_mandatory_correct').is(':checked')
      if !$('#essay_page_feedback').is(':checked')
        $('#essay_page_feedback').click()
    return
    
  $('#essay_page_feedback').on 'click', ->
    if !$('#essay_page_feedback').is(':checked')
      if $('#essay_page_mandatory_correct').is(':checked')
        $('#essay_page_mandatory_correct').click()
    return
  return